// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"GlobalUsersTable_ProseMirror__3ihae","table_empty":"GlobalUsersTable_table_empty__fZWCf","rotate-shadow":"GlobalUsersTable_rotate-shadow__2HtQX"};